import React from 'react';
import EnhancedDialog from '../../EnhancedDialog';

interface RecordDeleteDialogProps {
  isOpen: boolean;
  deletionInfo: {
    deletedAt: Date;
  } | null;
  onClose: () => void;
  onGoHome: () => void;
}

const RecordDeleteDialog: React.FC<RecordDeleteDialogProps> = ({
  isOpen,
  deletionInfo,
  onClose,
  onGoHome
}) => {
  return (
    <EnhancedDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Record Deleted"
      canOutsideClickClose={false}
      canEscapeKeyClose={true}
    >
      <div className="sky-dialog-body">
        <p style={{ fontSize: '14px' }}>
          This record was deleted{' '}
          {deletionInfo?.deletedAt && `at ${deletionInfo.deletedAt.toLocaleTimeString()}`}.
        </p>
        <p style={{ fontSize: '13px', color: 'var(--text-3)' }}>
          You can close this dialog to view the deleted data for reference,
          but you will not be able to make any changes.
        </p>
      </div>
      <div className="sky-dialog-footer">
        <button className="sky-btn sky-btn-ghost" onClick={onClose}>Close</button>
        <button className="sky-btn sky-btn-primary" onClick={onGoHome}>Go to Main Page</button>
      </div>
    </EnhancedDialog>
  );
};

export default RecordDeleteDialog;
